
<template>
  <div class="contacts-wrapper">
    <Header :has-section-title="true" title="Contact us"></Header>
    <Menu :is-open="isMenuOpen" @toggleMenu="toggleMenu"></Menu>
    <main class="contacts">
      <form class="contacts__form form" ref="contact_form" @submit.prevent="submit">
        <div class="form__block" :class="{ 'form__block--hasError': errors.has('name') }">
          <input
            type="text"
            class="form__input"
            name="name"
            placeholder="your name"
            @focus="removeErrorState('name')"
          />
          <label class="form__label">Your name</label>
          <span class="form__error-block">{{ errors.get('name') }}</span>
        </div>
        <div class="form__block" :class="{ 'form__block--hasError': errors.has('last_name') }">
          <input
            type="text"
            class="form__input"
            name="last_name"
            placeholder="your last name"
            @focus="removeErrorState('last_name')"
          />
          <label class="form__label">Your last name</label>
          <span class="form__error-block">{{ errors.get("last_name") }}</span>
        </div>

        <div class="form__block" :class="{ 'form__block--hasError': errors.has('email') }">
          <input
            type="text"
            class="form__input"
            name="email"
            placeholder="email"
            @focus="removeErrorState('email')"
          />
          <label class="form__label">Your email</label>
          <span class="form__error-block">{{ errors.get("email") }}</span>
        </div>

        <div class="form__block" :class="{ 'form__block--hasError': errors.has('message') }">
          <textarea
            name="message"
            class="form__textarea"
            placeholder="message"
            @focus="removeErrorState('message')"
          ></textarea>
          <label class="form__label">Message</label>
          <span class="form__error-block">{{ errors.get("message")}}</span>
        </div>

        <button class="button button--withBorder form__button" type="submit">send a message</button>
      </form>
      <div class="contacts__info info">
        <h2 class="info__title">Have a new idea for a photo?</h2>
        <p class="info__description">
          You enjoy what I do and would like to order a photosession. That is
          easy. You can send a message.
        </p>
      </div>
    </main>
    <NotificationModal :is-visible="showModal" @close="showModal = false">
      <p class="modal__paragraph">
        <unicon name="check-square" width="40" height="40"></unicon>Your e-mail has been successfully delivered
      </p>
    </NotificationModal>
    <Footer></Footer>
  </div>
</template>

<script>
import Header from "../components/Header";
import Footer from "../components/Footer";
import Menu from "../components/Menu";
import NotificationModal from "../components/NotificationModal";
import { MenuMixin } from "../mixins";
import api from "../services";

export default {
  mixins: [MenuMixin],
  data: () => ({
    errorMessages: {
      EMPTY_FIELD: "Field is empty. Please fill it.",
      WRONG_EMAIL:
        "Format of current email is wrong. Please enter correct email address."
    },
    errors: new Map(),
    showModal: false
  }),
  methods: {
    submit() {
      if (!this.isFormValid()) {
        return;
      }

      const {
        message: { value: message },
        name: { value: name },
        last_name: { value: last_name },
        email: { value: email }
      } = this.$refs.contact_form;

      const body = { message, email, fullname: `${name} ${last_name}` };

      api
        .sendMail(JSON.stringify(body))
        .then(() => {
          this.showModal = true;
        })
        .catch(() => {});
    },
    showError(field, error) {
      this.errors.set(field.name, error);
    },
    removeErrorState(field) {
      this.errors.delete(field);
      this.$forceUpdate();
    },
    isEmailNotValid(email) {
      if (this.errors.has("email")) {
        return false;
      }

      const regExp = /^(([^<>()\\[\]\\.,;:\s@"]+(\.[^<>()\\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

      return !regExp.test(email);
    },
    isFormValid() {
      const { message, name, last_name, email } = this.$refs.contact_form;

      const { WRONG_EMAIL, EMPTY_FIELD } = this.errorMessages;

      [message, name, last_name, email].forEach(
        field => this.isEmpty(field.value) && this.showError(field, EMPTY_FIELD)
      );

      this.isEmailNotValid(email.value) && this.showError(email, WRONG_EMAIL);
      this.$forceUpdate();

      return this.errors.size === 0;
    },
    isEmpty(value) {
      return value.length === 0;
    }
  },
  components: { Header, Footer, Menu, NotificationModal }
};
</script>
